export default "__VITE_ASSET__jzYLocPX__"